/* eslint no-param-reassign: ["error", { "props": false }] */

import RiotControl from 'riotcontrol'
import FulfillmentUtils from '../utils/fulfillment-utils.js'
import AnalyticsStrings from '../metrics/strings.js'

export default {

  triggerItemUnavailableModal: (data) => {
    const buttons = []
    const auditType = data.isOrderSummary ? 'auditOrderWithEADs' : 'auditOrder'
    // Only add the Edit in cart button if the unavailability is not absolute
    if (data.orderSize !== data.oosProducts.length) {
      buttons.push({
        title: 'Edit in cart',
        el_classes: 'btn btn-secondary',
        on_click: () => {
          RiotControl.trigger('analytics.sendClick', { linkName: AnalyticsStrings.link.unavailableEditInCart })
          window.location = '/ShoppingCart' // eslint-disable-line
        },
      })
    }

    // Always add the continue button
    buttons.push({
      title: 'Continue',
      el_classes: 'btn btn-primary',
      on_click: () => {
        RiotControl.trigger('analytics.sendClick', { linkName: AnalyticsStrings.link.unavailableRemoveFromOrder })
        // Navigate back to cart if the order has nothing left
        if (data.orderSize === data.oosProducts.length) {
          return new Promise(resolve => RiotControl.trigger('deleteItems', data.oosProducts.concat(data.partialOosProducts), resolve))
            .then(() => Promise.resolve((window.location = '/ShoppingCart'))); // eslint-disable-line
        }

        return new Promise(resolve =>
          RiotControl.trigger('deleteItems', data.oosProducts.concat(data.partialOosProducts), resolve))
          .then(items =>
            new Promise(resolve => RiotControl.trigger(auditType, () => resolve(items))))
      },
    })

    // Trigger the modal
    RiotControl.trigger('modalFactory.create', {
      title: 'The following products are no longer available and will be removed from your order',
      template: 'items-unavailable-modal',
      noClose: true,
      width: 400,
      data: {
        oosProducts: data.oosProducts,
        partialOosProducts: data.partialOosProducts,
        finishOrder: data.orderSize === data.oosProducts.length,
      },
      buttons,
    })
    RiotControl.trigger('analytics.sendClick', { linkName: AnalyticsStrings.link.unavailableModal })
  },

  doBackorderModal: ({ lineItems, fulfillmentsModel, isOrderSummary }) => {
    const allBackorderProducts = FulfillmentUtils.getBackorderedProducts(lineItems)
    const allOosProducts = FulfillmentUtils.getUnavailableProducts(lineItems, fulfillmentsModel, isOrderSummary)

    // Check if any backordered products are also unavailable, which happens if the user is
    // trying to purchase more than we have in future inventory. If there are such products
    // we want merge the unavailable inventory into the backordered item and remove it from
    // the unavailable array. This is to prevent the item from showing up in both sections
    // of the modal
    allBackorderProducts.forEach((boItem) => {
      allOosProducts.forEach((oosItem, index) => {
        if (boItem.reiRefId === oosItem.reiRefId) {
          boItem.availability.quantity -= oosItem.quantity - oosItem.availability.quantity
          allOosProducts.splice(index, 1)
        }
      })
    })

    if (allBackorderProducts.length > 0 || allOosProducts.length > 0) {
      const orderSize = lineItems.length
      const unavailableSize = allOosProducts.length + allBackorderProducts.length
      const backorderProducts = allBackorderProducts.filter(p => p.availability.quantity === 0)
      const partialBackorderProducts = allBackorderProducts.filter(p => p.availability.quantity !== 0)
      const oosProducts = allOosProducts.filter(p => p.availability.quantity === 0)
      const partialOosProducts = allOosProducts.filter(p => p.availability.quantity !== 0)

      if (unavailableSize) {
        RiotControl.trigger('analytics.sendClick', { linkName: AnalyticsStrings.link.unavailableModal })
      }

      RiotControl.trigger('modalFactory.create', {
        title: `Item${unavailableSize > 1 ? 's' : ''} no longer available`,
        template: 'notify-me-modal',
        noClose: true,
        width: 400,
        data: {
          orderSize,
          oosProducts,
          backorderProducts,
          partialOosProducts,
          partialBackorderProducts,
          isOrderSummary,
        },
      })
    }
  },

  backorderInfoClick: (e) => {
    e.preventDefault()

    RiotControl.trigger('modalFactory.create', {
      title: 'Backorder and preorder info',
      template: 'backorder-preorder-modal',
    })
  },
}
